import React, { Component } from 'react';
import '../App.css';
import '../styles/employers.css';
import oneIcon from '../assets/for-employers/number-one.svg';
import twoIcon from '../assets/for-employers/number-two.svg';
import threeIcon from '../assets/for-employers/number-three.svg';
import fourIcon from '../assets/for-employers/number-four.svg';
import fiveIcon from '../assets/for-employers/number-five.svg';
import CarouselSlider from "./carousel-slider";
import { HashLink as Link } from 'react-router-hash-link';
import Fade from 'react-reveal/Fade';
import VisibilitySensor from 'react-visibility-sensor';

import bannerImage from '../assets/for-employers/Panel-Business-Card.svg';

import lifesaver from '../assets/for-employers/WhatIfINeedHelp_animation.gif';
import personalizedCard from '../assets/for-employers/FintwistCardArt_Lee_M-01.svg';
import instantIssueCard from '../assets/for-employers/FintwistCardArt_Generic.svg';

// Slide graphics //
import leaveChecks from '../assets/for-employers/LeaveChecks_Animation.gif';
import paperlessGraphic from '../assets/for-employers/AndGoPaperless_animation.gif';

// how it works section graphics //
import howItWorks1 from '../assets/for-employers/Employer_1.svg';
import howItWorks2 from '../assets/for-employers/Employer_2.svg';
import howItWorks3 from '../assets/for-employers/Employer_3.svg';
import howItWorks4 from '../assets/for-employers/Employer_4.svg';
import howItWorks5 from '../assets/for-employers/Employer_5.svg';

import employeeTransitionGraphicGif from '../assets/for-employers/employee-section-transition.svg';

class EmployerExperience extends Component {

  constructor(props){
    super(props)
    this.state = {
      leaveChecksGif: leaveChecks,
      paperlessTreesGif: paperlessGraphic
    }
  }

  render() {

    return (
      <section id="for-employers-section">
        <div id="for-employers-section-1">
          <div className="section-width-wrapper banner-wrapper">
            <div className="banner-text section-title-text-wrapper">
              <p className="section-header">
              DO IT FOR YOUR BUSINESS
              </p>
              <p className="section-body">
                Simplify your day with paycards.
              </p>
            </div>
            <img className="banner-image" src={bannerImage} alt={''} />
            <div className="down-button-container">
              <Link to={`/slides#for-employers-section-2`}
                className="down-button-background">
                <i className="fa fa-angle-down" />
              </Link>
            </div>
          </div>
        </div>
        <div id="for-employers-section-2" className="for-employers-section-wrapper">
        <VisibilitySensor>
          {({isVisible}) =>
            <img src={this.state.leaveChecksGif} alt={''} />
          }
        </VisibilitySensor>
          <div className="section-title-text-wrapper">
            <Fade bottom>
              <p className="section-header">
                LEAVE CHECKS IN THE PAST
              </p>
              <p className="section-body">
                Forget dealing with lost checks, stop-payments, check sorting, check delivery, and reconciliation.
              </p>
            </Fade>
          </div>
        </div>
        <div id="for-employers-section-3" className="for-employers-section-wrapper reverse-column">
          <div className="section-title-text-wrapper">
            <Fade bottom>
              <p className="section-header">
                AND GO PAPERLESS
              </p>
              <p className="section-body">
                When we eliminate your checks, you’ll say hello to 100% direct deposit, easy paydays, and stress-free weekends.
              </p>
              <Link to={`/contact`}>
                <button>Find out if your company qualifies</button>
              </Link>
            </Fade>
          </div>
          <Fade bottom>
          <VisibilitySensor
            delayedCall
          >
          {({isVisible}) =>
            <img src={this.state.paperlessTreesGif} alt={''} />
          }
          </VisibilitySensor>          
          </Fade>
        </div>
        <div id="for-employers-section-4" className="for-employers-section-wrapper">
          <div className="section-title-text-wrapper centered-section">
            <div className="centered-section-1">
              <Fade bottom cascade>
                <div>
                  <p className="section-header">
                    HOW IT WORKS:
                  </p>
                  <p id="how-it-works-subtitle">
                    Implementation is simple, only takes a short period of time, and requires no changes to your existing payroll process.
                  </p>
                </div>
              </Fade>
                <Fade bottom cascade>
                <div className="how-it-works-step">
                  <img src={oneIcon} alt={""} />
                  <p>Let’s get you approved</p>
                  <p className="section-body">We just need to make sure you're legit.</p>
                </div>
                <div className="how-it-works-step">
                  <img src={twoIcon} alt={""} />
                  <p>Launch Implementation Strategy</p>
                  <p className="section-body">We’ll assign a resource to work on your customized roll out strategy.</p>
                </div>
                <div className="how-it-works-step">
                  <img src={threeIcon} alt={""} />
                  <p>Enroll your employees</p>
                  <p className="section-body">We make it easy with automated or batch enrollments.</p>
                </div>
                <div className="how-it-works-step">
                  <img src={fourIcon} alt={""} />
                  <p>Receive and distribute your cards</p>
                  <p className="section-body">We’ll use your enrollment data to get you cards in 4-6 business days.</p>
                </div>
                <div className="how-it-works-step">
                  <img src={fiveIcon} alt={""} />
                  <p>Update your Payroll</p>
                  <p className="section-body">Fintwist Paycards work like any direct deposit – just enter the routing and account numbers and you’re done.</p>
                </div>
              </Fade>
            </div>
            <div className="centered-section-2">
              <div id="for-employers-section-4-graphic">
                <Fade bottom cascade>
                  <div className="icon-container">
                    <img src={howItWorks1} alt={''} />
                  </div>
                  <div className="icon-container">
                    <img src={howItWorks2} alt={''} />
                  </div>
                  <div className="icon-container">
                    <img src={howItWorks3} alt={''} />
                  </div>
                  <div className="icon-container">
                    <img src={howItWorks4} alt={''} />
                  </div>
                  <div className="icon-container">
                    <img src={howItWorks5} alt={''} />
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
        <div id="for-employers-section-5">
          <Fade bottom cascade>
            <div className="section-title-text-wrapper">
              <div className="col-1">
                <p className="section-header">
                  WHAT IF I NEED HELP?
                </p>
                <p>
                  We have a team of Account Managers dedicated to making your life easier.
                </p>
              </div>
              <img src={lifesaver} alt={''} />
            </div>
          </Fade>
        </div>
        <div id="for-employers-section-6">
          <Fade bottom cascade>
            <div className="section-title-text-wrapper">
              <p className="section-header">
                WHAT ABOUT NEW HIRES?
              </p>
              <p className="section-body">
                Here's how we handle the one-offs.
              </p>
            </div>
            <div className="section-column">
              <div className="section-row">
                <div className="new-hires-text column">
                  <img src={personalizedCard} alt={''} />
                  <p>Personalized Cards</p>
                  <p className="section-body">Personalized Cards take a few days to ship, but they come with the employee’s name embossed. We recommend using this option wherever possible!</p>
                </div>
                <div className="new-hires-text column">
                  <img src={instantIssueCard} alt={''} />
                  <p>Instant Issue Cards</p>
                  <p className="section-body">We’ll supply you with an inventory of Instant Issue cards. These cards are great to get someone set up for direct deposit immediately.</p>
                </div>
              </div>
            </div>
          </Fade>
        </div>
        <div id="for-employers-section-7">
          <Fade bottom>
            <div className="section-title-text-wrapper">
              <p className="section-header">
                FAQ SPEED<br />ROUND
              </p>
              <p className="section-body">
                Ready.. set.. GO!
              </p>
            </div>
            <CarouselSlider />
          </Fade>
        </div>
        <div id="for-employers-section-8" className="for-employers-section-wrapper reverse-column">
          <Fade bottom>
            <div className="section-title-text-wrapper">
              <p className="section-header">
                WHAT'S IT LIKE<br />FOR MY EMPLOYEES?
              </p>
              <p className="section-body">
                Let us show you! Keep scrolling.
              </p>
            </div>
            <VisibilitySensor
              delayedCall
            >
              {({isVisible}) =>
                <img src={employeeTransitionGraphicGif} alt={''} />
              }
            </VisibilitySensor>
            </Fade>
            <div className="down-button-container">
          <Link to={`/slides#cardholder-experience-section`}
            className="down-button-background">
            <i className="fa fa-angle-down" />
          </Link>
        </div>
        </div>
      </section>
    );
  }
}

export default EmployerExperience;
